import PowerBI from './power-bi';

export default PowerBI;
